import apiLmsConteudo from '../../../services/apiLmsConteudo';

const MIME_BY_EXT = {
  jpg: 'image/jpeg', jpeg: 'image/jpeg',
  png: 'image/png', gif: 'image/gif',
  webp: 'image/webp', svg: 'image/svg+xml',
  bmp: 'image/bmp', tiff: 'image/tiff',
  mp4: 'video/mp4', webm: 'video/webm',
  pdf: 'application/pdf',
};

function resolveContentType(file) {
  if (file.type) return file.type;
  const ext = file.name.split('.').pop().toLowerCase();
  return MIME_BY_EXT[ext] || 'application/octet-stream';
}

function getFileName(file) {
  const fileNameSplitted = file.name.split('.');

  if (fileNameSplitted.length > 1) {
    fileNameSplitted.pop();
    return fileNameSplitted.join('.');
  }

  return fileNameSplitted[0];
}

export default async function upload(
  file,
  nome = null,
  categoria = null,
  aulaId = null,
  onUploadProgress
) {
  const fileType = file.type.split('/')[0];
  const fileSizeKb = file.size / 1000;

  if (nome === null) {
    nome = getFileName(file);
  }

  if (fileType === 'image' && fileSizeKb > 1024) {
    return Promise.reject(
      new Error('Não são permitidas imagens maiores que 1MB.')
    );
  }

  return new Promise((resolve, reject) => {
    uploadFile(file, aulaId, categoria, onUploadProgress)
      .then(data => {
        const tipo = file.type.split('/')[0];
        const saveAssetData = {
          url: data.url,
          categoria_id: categoria ? categoria.id : null,
          tipo,
          nome
        };
        apiLmsConteudo
          .post('/assets', saveAssetData)
          .then(() => {
            resolve(data);
          })
          .catch(err => reject(err));
      })
      .catch(err => {
        reject(err);
      });
  });
}

function getFileNameUpload(file) {
  try {
    const fileNameSplitted = file.name.split('.');
    const fileName =
      Date.now() + '.' + fileNameSplitted[fileNameSplitted.length - 1];
    return fileName;
  } catch (error) {
    return file.name;
  }
}

/**
 * Upload direto ao S3 via URL pré-assinada.
 * 1) Pede ao servidor uma URL pré-assinada
 * 2) Faz PUT do arquivo direto no S3
 * 3) Confirma no servidor para obter url/relativeUrl e cópia para aula se necessário
 */
async function uploadFile(file, aulaId, categoria, onUploadProgress) {
  const fileName = getFileNameUpload(file);

  const { data: presignedData } = await apiLmsConteudo.post(
    '/presigned-upload-url',
    {
      fileName,
      fileSize: file.size,
      contentType: resolveContentType(file),
      categoria: categoria?.nome ?? null,
      aulaId: aulaId ?? null,
    }
  );

  if (presignedData.error) {
    throw new Error(presignedData.error);
  }

  const { uploadUrl, keyname } = presignedData;

  await putFileToS3(uploadUrl, file, onUploadProgress);

  const { data: confirmData } = await apiLmsConteudo.post('/confirm-upload', {
    keyname,
    fileName,
    aulaId: aulaId ?? null,
    categoria: categoria?.nome ?? null,
  });

  if (confirmData.error) {
    throw new Error(confirmData.error);
  }

  return { url: confirmData.url, relativeUrl: confirmData.relativeUrl };
}

/**
 * Envia o arquivo via PUT para a URL pré-assinada do S3 (com suporte a progresso).
 */
function putFileToS3(uploadUrl, file, onUploadProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.upload.addEventListener('progress', (e) => {
      if (e.lengthComputable && onUploadProgress) {
        onUploadProgress((e.loaded / e.total) * 100);
      }
    });

    xhr.addEventListener('load', () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve();
      } else {
        reject(new Error(`Upload falhou: ${xhr.status} ${xhr.statusText}`));
      }
    });

    xhr.addEventListener('error', () => reject(new Error('Erro de rede no upload')));
    xhr.addEventListener('abort', () => reject(new Error('Upload cancelado')));

    xhr.open('PUT', uploadUrl);
    xhr.setRequestHeader('Content-Type', resolveContentType(file));
    xhr.send(file);
  });
}
